import {
    Component, ElementRef, Inject, Renderer2, ViewChild

} from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import * as _ from "lodash";
import { TranformtionImpactServerClientFilterObjectService } from '@src/services';
 import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';
 import {ImpactAnalysisDiffDialogComponent} from '@app/shared/components/dialogs/impact-analysis-diff-dialog/impact-analysis-diff-dialog.component'
 import { projectActions } from '@src/store/reducers/projectReducer';
 import {DialogManagerService } from '@src/services';
 import { Store } from '@src/store';
import { MatSort } from '@angular/material/sort';



export interface IDeployedPackagesTable {
    packageName: string;
    scriptName: string;
    action: string;
    status: string;
    viewChanges: string;
}

@Component({
    selector: 'impact-analysis-changes',
    template: require('./impact-analysis-changes.html'),
    styles: [require('./impact-analysis-changes.scss')]
})
export class ImpactAnalysisChangesComponent {
    public projectId: any;
    public dplModeType: any;
    public environmentId: string;
    public policyEnums:any;
    public processData:any;
 

    // tslint:disable-next-line:variable-name

    public displayedColumns = ['packageName', 'scriptName', 'action', 'status', 'viewChanges'];
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    @ViewChild(MatSort) public sort: MatSort;
    private pressed = false;
  //  private currentResizeIndex: number;
    private startX: number;
    private startWidth: number;
    private isResizingRight: boolean;
    private resizableMousemove: () => void;
    private resizableMouseup: () => void;

    @ViewChild(MatTable, { read: ElementRef }) private matTableRef: ElementRef;
    private columns: any[] = [
        { field: 'packageName', width: 300 },
        { field: 'scriptName', width: 300 },
        { field: 'action', width: 350 },
        { field: 'status', width: 300 },
        { field: 'viewChanges', width: 250 },
    ];

    constructor(
        private store: Store,
        @Inject('$stateParams') private $stateParams: any,
        @Inject('$filter') private $filter: any,
        private renderer: Renderer2,
        private dialogManagerService: DialogManagerService , 
        private tranformtionImpactServerClientFilterObjectService : TranformtionImpactServerClientFilterObjectService

    ) {
    

    }

    public async ngOnInit() {
        this.policyEnums = await this.store.dispatch({type:policyEngineActions.GET_POLICIES_ACTIONS})
        this.processData =  this.processData = this.tranformtionImpactServerClientFilterObjectService.getNewjsonData(this.store.getState().project.impact_analysis, this.store.getState().enums,this.$stateParams.jobEnv,this.$filter('changeEnumJobNameToName'));
        const data = [];
        if(this.processData.changes){
            this.processData.changes.forEach((item) => {
                data.push({
                    source_schema : item.source_schema,
                    object_name:item.object_name ,
                    object_type : item.object_type,
                    status: item.status,
                    entity : item,
                });
            });
            this.dataSource.data = data;
        }
      
    }


    getStatusColor(item){
        if(item.entity){
            if (item.entity.raw.ChangeTypeId == 0 && !item.entity.IsDrift) { return "addedStatus" }
            if (item.entity.raw.ChangeTypeId == 2) { return "updatedStatus" }
            return "deletedStatus"
        }
        
    }

   async onViewChanges(entity) {
            let schemaId = this.getSchemaIdViaRefrence(entity);
           await this.store.dispatch({
                type: projectActions.GET_IMPACT_ANALYSIS_VIEW_CHANGES,
                payload: {
                    type: this.processData.jobType,
                    projectId: this.processData.projectId,
                    jobId: this.processData.jobId,
                    envId: entity.envId,
                    schemaId,
                    reportId: this.$stateParams.reportId,
                    objectType: entity.object_type,
                    objectName: entity.object_name
                }
            }).then(x => {
                if(x){
                        let sourceCode = this.store.getState().project.impact_analysis_script.SourceScriptDataPerSchema
                        let targetCode = this.store.getState().project.impact_analysis_script.TargetScriptDataPerSchema
                        if (this.store.getState().project.impact_analysis_script) {
                                const dialogData = {
                                    baselineCode : null,
                                    sourceCode : sourceCode,
                                    targetCode : targetCode,
                                    isBuild : entity.entity.is_build,
                                    envName : entity.entity.env_name
                                   
                                };
                                this.dialogManagerService.showDialog(dialogData, null ,ImpactAnalysisDiffDialogComponent , 'impact-analysis-diff-dialog');
                            } 
                }
            })
    
       }


    getSchemaIdViaRefrence(item) {
        let entityId = item.entity.id;
        switch (this.processData.referenceScope) {
            case 'target':
                entityId = this.getTargetSchemaId(item.entity);
                break;
        }
        return entityId;
    }

    getTargetSchemaId(entity) {
        let entityId = entity.id;
        const sourceScope = _.find(this.processData.scopes, (scope) => {
            return scope.SourceSchema.id == entityId
        });
        if (sourceScope) {
            entityId = sourceScope.TargetSchema.id;
        }
        return entityId;
    }


    public ngAfterViewInit() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);

    }
  private setTableResize(tableWidth: number) {
        let totWidth = 0;
        this.columns.forEach((column) => {
            totWidth += column.width;
        });
        const scale = (tableWidth - 5) / totWidth;
        this.columns.forEach((column) => {
            column.width *= scale;
            this.setColumnWidth(column);
        });
    }
    

    public onResizeColumn(event: any, index: number) {
        this.checkResizing(event, index);
       // this.currentResizeIndex = index;
        this.pressed = true;
        this.startX = event.pageX;
        this.startWidth = event.target.clientWidth;
        event.preventDefault();
        this.mouseMove(index);
    }


private checkResizing(event, index) {
        const cellData = this.getCellData(index);
        if ((index === 0) ||
            (Math.abs(event.pageX - cellData.right) < cellData.width / 2 && index !== this.columns.length - 1)) {
            this.isResizingRight = true;
        } else {
            this.isResizingRight = false;
        }
    }

    private getCellData(index: number) {
        const headerRow = this.matTableRef.nativeElement.children[0];
        const cell = headerRow.children[0].children[index];
        return cell.getBoundingClientRect();
    }

    private mouseMove(index: number) {
        this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
            if (this.pressed && event.buttons) {
                const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
                const width = this.startWidth + dx;
               // if (this.currentResizeIndex === index && width > 50) {
                    this.setColumnWidthChanges(index, width);
               // }
            }
        });
        this.resizableMouseup = this.renderer.listen('document', 'mouseup', () => {
            if (this.pressed) {
                this.pressed = false;
           //     this.currentResizeIndex = -1;
                this.resizableMousemove();
                this.resizableMouseup();
            }
        });
    }

    private setColumnWidthChanges(index: number, width: number) {
        const orgWidth = this.columns[index].width;
        const dx = width - orgWidth;
        if (dx !== 0) {
            const j = (this.isResizingRight) ? index + 1 : index - 1;
            const newWidth = this.columns[j].width - dx;
            // if (newWidth > 50) {
                this.columns[index].width = width;
                this.setColumnWidth(this.columns[index]);
                this.columns[j].width = newWidth;
                this.setColumnWidth(this.columns[j]);
            // }
        }   
    }

    private setColumnWidth(column: any) {
        const columnEls = Array.from(document.getElementsByClassName(`mat-column-${column.field}`));
        columnEls.forEach((el: HTMLDivElement) => {
            const packageNameElement = Array.from(el.getElementsByClassName('dp-package-name'));
            if (packageNameElement && packageNameElement.length > 0) {
                const el1: HTMLElement = packageNameElement[0] as HTMLElement;
                el1.style.width = `${column.width}px`;
            }
            el.style.width = `${column.width}px`;
        });
    }

   // @HostListener('window:resize', ['$event'])
    public onResize() {
        this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/impact-analysis/impact-analysis-changes-ang7/impact-analysis-changes.ts